<script>
	import IconButton from '@smui/icon-button';
	import List, { Item, Text } from '@smui/list';
	import Menu from "@smui/menu";
	import TopAppBar, { Row, Section } from '@smui/top-app-bar';
	import AppStore from "../../AppStore";
	import AuthState from "../../Auth/Enums/AuthState";
	import AuthStore from "../../Auth/Store";
	import GNSSHotspotsStore from "../../Aviation/GNSSHotspots/Store";
	import NOTAMStore from "../../Aviation/NOTAMStore";
	import Feature from "../../Branding/Feature";
	import { identity } from "../../Branding/Store";
	import User from "../../Branding/User";
	import SatCapStore from "../../Environment/SatCap/Store";
	import SatRFStore from "../../Environment/SatRF/Store";
	import MapStore from "../../Map/Store";
	import ShippingLanesFiltersStore from "../../ShippingLanes/ShippingLaneFilter/Store";
	import ShippingLanesStore from "../../ShippingLanes/Store";
	import AdminStore from "../../UI/Admin/Store";
	import AnnotationsStore from "../../UI/Annotations/Store";
	import CompanyStore from "../../UI/Dashboards/Company/Store";
	import UserPreferencesStore from "../../UI/Dashboards/UserPreferences/Store";
	import HydrographicChartStore from "../../UI/HydrographicCharts/Store";
	import ImageCollectionsStore from "../../UI/ImageCollections/Store";
	import MARMANsStore from "../../UI/MARMANs/Store";
	import MaritimeBoundariesStore from "../../UI/MaritimeBoundaries/Store";
	import PortsStore from "../../UI/Ports/Store";
	import UKHOWindStore from "../../UKHO/UKHOWindStore";
	import HotspotsStore from "../Hotspots/Store";
	import RoutePlottingStore from "../MeasureTool/RoutePlottingStore";
	import CablesStore from "../NationalGrid/CablesStore";
	import NotepadStore from "../Notepad/Store";
	import RiskIntStore from "../RiskInt/IncidentsStore";
	import RiskIntPortsStore from "../RiskInt/PortsStore";
	import RoutingStore from "../Routing/Store";
	import SatelliteViewStore from "../SatelliteView/Store";
	import Tooltip from '../Tooltip.svelte';
	import "./Banner.scss";
	import BannerMenuItem from "./BannerMenuItem.svelte";

	let open = AppStore.menu.visible;
	let cmsOpen = AdminStore.cms.visible;
	let loginState = AuthStore.meta.state;

	$: menuIcon = (!$open)?"menu":"arrow_back";
	$: menuTooltip = (!$open)?"Menu (M)":"Close(M)";

	let addContextMenu = null;
	let userContextMenu = null;

	let hasAviationFeatures = false;
	let hasHazardsFeatures = false;
	let hasToolsFeatures = false;
	let hasMaritimeFeatures = false;
	let hasMiscFeatures = false;

	let hasCMS = false;

	let currentUserInfo = AuthStore.userInfo;
	let currentUserCompanyInfo = AuthStore.session.company;

	$: {
		$loginState;

		hasCMS = User.hasFeature(Feature.ADMIN.VIEW);
		hasAviationFeatures = User.hasAnyOfFeatures([
			Feature.AVIATION.NOTAMS.VIEW,
			Feature.AVIATION.ALERTS.VIEW
		]);
		hasHazardsFeatures = User.hasAnyOfFeatures([
			Feature.HURRICANES.VIEW,
			Feature.FLOODS.VIEW,
			Feature.EARTHQUAKES.VIEW,
			Feature.VOLCANOES.VIEW
		]);
		hasToolsFeatures = User.hasAnyOfFeatures([
			Feature.MEASURE.VIEW,
			Feature.NOTEPAD.VIEW
		]);
		hasMiscFeatures = User.hasAnyOfFeatures([
			Feature.SANCTIONS.VIEW,
			Feature.TIMEZONES.VIEW,
			Feature.IMAGE_ASSETS.VIEW,
			Feature.ANNOTATIONS.VIEW
		]);
		hasMaritimeFeatures = User.hasAnyOfFeatures([
			Feature.SHIPPING_LANES.VIEW,
			Feature.MARITIME.SHIPPING_LANE_ROUTING.VIEW,
			Feature.MARITIME.NAUTICAL_CHARTS.VIEW,
			Feature.MARITIME.BOUNDARIES.VIEW,
			Feature.PORT_ASSESSMENTS.VIEW
		]);
	}

	let openCompanyDashboard = () => {
		CompanyStore.dashboard.meta.visible.set(true);
	};
	let openUserPreferences = () => {
		UserPreferencesStore.dashboard.meta.visible.set(true);
	};
	let openMapSettings = () => {
		SatelliteViewStore.meta.visible.set(true);
	};
</script>

<TopAppBar class="banner drop-shadow" collapsed={false}>
	{#if $loginState === AuthState.LOGGED_IN}
		<Row >
			<Section>
				<Tooltip text={menuTooltip}>
					<IconButton class="material-icons" on:click={AppStore.actions.toggleMenu}>
						{menuIcon}
					</IconButton>
				</Tooltip>
			</Section>
			<Section align="end" toolbar>
				<Tooltip text="Add">
					<IconButton class="material-icons" aria-label="Add" on:click={()=>{
						addContextMenu.setOpen(true);
					}}>add</IconButton>
				</Tooltip>
				<Tooltip text="Settings">
					<IconButton class="material-icons" aria-label="Settings" on:click={()=>{
						userContextMenu.setOpen(true);
					}}>settings</IconButton>
				</Tooltip>
			</Section>
		</Row>
		<div class='logo-container'>
			<a href='/'><img class="logo" src={$identity.logo} title={$identity.name} alt={$identity.name} /></a>
		</div>
	{:else}
		<div class='container'>
			<div class='logo-container logged-out'>
				<a href='/'><img class="logo" src={$identity.logo} title={$identity.name} alt={$identity.name} /></a>
			</div>
		</div>

	{/if}
</TopAppBar>

<div class="add-item-context-menu-container">
	<Menu bind:this={addContextMenu} anchorCorner="TOP_RIGHT" style="width:280px;">
		<List>
			{#if hasCMS}
				<h2 class="list-heading">Admin</h2>
				<BannerMenuItem name="CMS" materialIcon="supervisor_account" requireFeature={Feature.ADMIN.VIEW} visible={AdminStore.cms.visible} />
			{/if}

			{#if hasAviationFeatures}
				<h2 class="list-heading">Aviation</h2>
				<BannerMenuItem name="NOTAMs" materialIcon="flight" requiresFeature={Feature.AVIATION.NOTAMS.VIEW} visible={NOTAMStore.meta.visible} />
				<BannerMenuItem name="GNSS Interference Hotspots" materialIcon="adjust" requiresFeature={Feature.AVIATION.ALERTS.VIEW} visible={GNSSHotspotsStore.meta.visible} />
			{/if}

			<h2 class="list-heading">Maritime</h2>
			<BannerMenuItem
				name="Shipping Lanes"
				icon="shippinglanes"
				requiresFeature={Feature.SHIPPING_LANES.VIEW}
				visible={ShippingLanesStore.visible}
				onclick={() => ShippingLanesFiltersStore.fetchFilters()}
			/>
			<BannerMenuItem name="Shipping Lanes - Routing"	icon="shippinglanes" 		requiresFeature={Feature.MARITIME.SHIPPING_LANE_ROUTING.VIEW}			visible={RoutingStore.meta.visible} />
			<BannerMenuItem name="Ship-to-ship Hotspots"	materialIcon="adjust" 		requiresFeature={Feature.MARITIME.HOTSPOTS.STS.VIEW} 			visible={HotspotsStore.meta.visible} />
			<BannerMenuItem name="Nautical Charts" 			icon="nauticalcharts" 		requiresFeature={Feature.MARITIME.NAUTICAL_CHARTS.VIEW} 		visible={HydrographicChartStore.meta.visible} />
			<BannerMenuItem name="Boundaries (EEZ/TTW)" 	icon="maritimeboundaries" 	requiresFeature={Feature.MARITIME.BOUNDARIES.VIEW} 				visible={MaritimeBoundariesStore.meta.visible} />
			<BannerMenuItem name="Port Assessments" 		icon="portassessments" 		requiresFeature={Feature.PORT_ASSESSMENTS.VIEW} 				visible={AppStore.portAssessments.visible} />
			<BannerMenuItem name="Ports" 					icon="port" 																				visible={PortsStore.meta.visible} />
			<BannerMenuItem name="Risk Intelligence - Ports" 			icon="port" 	requiresFeature={Feature.MARITIME.RISKINTELLIGENCE.PORTS.VIEW} 		visible={RiskIntPortsStore.meta.visible} />
			<BannerMenuItem name="Risk Intelligence - Incidents" 		icon="warning" 	requiresFeature={Feature.MARITIME.RISKINTELLIGENCE.INCIDENTS.VIEW} 	visible={RiskIntStore.meta.visible} />
			<BannerMenuItem name="Incidents" 				icon="warning" 				requiresFeature={Feature.MARITIME.MISS.VIEW} 		 			visible={AppStore.miss.visible} />
			<BannerMenuItem name="Offshore Infrastructure"  materialIcon="home"			requiresFeature={Feature.MARITIME.OFFSHORE_INFRASTRUCTURE.VIEW} visible={UKHOWindStore.meta.visible}  />
			<BannerMenuItem name="MARMANs" 	  				icon="warning" 				requiresFeature={Feature.MARITIME.MARMANS.VIEW}  				visible={MARMANsStore.meta.visible} />
			<BannerMenuItem name="Undersea Cables" 	  		icon="shippinglanes" 		requiresFeature={Feature.MARITIME.NATIONALGRID.UNDERSEA_CABLES.VIEW} visible={CablesStore.meta.visible} />

			{#if hasHazardsFeatures}
				<h2 class="list-heading">Natural Hazards</h2>
				<BannerMenuItem name="Tropical Storms" 	icon="hurricanes" 	requiresFeature={Feature.HURRICANES.VIEW} 	visible={MapStore.hurricanesVisible} />
				<BannerMenuItem name="Floods" 			icon="floods" 		requiresFeature={Feature.FLOODS.VIEW} 		visible={AppStore.hazards.floods.visible} />
				<BannerMenuItem name="Earthquakes" 		icon="earthquakes" 	requiresFeature={Feature.EARTHQUAKES.VIEW} 	visible={AppStore.hazards.earthquakes.visible} />
				<BannerMenuItem name="Volcanoes" 		icon="volcanoes" 	requiresFeature={Feature.VOLCANOES.VIEW} 	visible={AppStore.hazards.volcanoes.visible} />
			{/if}

			<h2 class="list-heading">Tools</h2>
			{#if hasToolsFeatures}
				<BannerMenuItem name="Route Plotting" 	materialIcon="square_foot"	requiresFeature={Feature.MEASURE.VIEW} 		visible={RoutePlottingStore.meta.visible} />
				<BannerMenuItem name="Annotations" 		materialIcon="brush" 		requiresFeature={Feature.ANNOTATIONS.VIEW} 	visible={AnnotationsStore.meta.visible} />
				<BannerMenuItem name="Notepad" 			materialIcon="notes" 		requiresFeature={Feature.NOTEPAD.VIEW} 		visible={NotepadStore.meta.visible} />
			{/if}

			<h2 class="list-heading">Miscellaneous</h2>
			{#if hasMiscFeatures}
				<BannerMenuItem name="Sanctions" 	icon="warning"	requiresFeature={Feature.SANCTIONS.VIEW} visible={MapStore.sanctionsVisible} />
				<BannerMenuItem name="Timezones" 	icon="timezone" requiresFeature={Feature.TIMEZONES.VIEW} visible={MapStore.timezoneVisible} />
				<BannerMenuItem name="Image Collections" 	materialIcon="collections" requiresFeature={Feature.IMAGE_ASSETS.VIEW} visible={ImageCollectionsStore.meta.visible} />
				<BannerMenuItem name="SAR-derived Dark Vessel Detection" materialIcon="satellite" requiresFeature={Feature.SAR_DVD.VIEW} visible={SatCapStore.meta.visible} />
				<BannerMenuItem name="Satellite-derived RF Detection" materialIcon="satellite" requiresFeature={Feature.SATELLITE_RFD.VIEW} visible={SatRFStore.meta.visible} />
			{/if}
		</List>
	</Menu>
</div>

<div class="user-item-context-menu-container">
	<Menu bind:this={userContextMenu} anchorCorner="TOP_RIGHT" style="width:320px;">
		<List>
			<h2 class="list-heading">Settings:</h2>
			<Item on:SMUI:action={openUserPreferences}>
				<div class={"list-item-icon material-icons opacity-full"}>account_circle</div>
				<Text><span class="opacity-full">User Preferences</span></Text>
			</Item>
			<Item on:SMUI:action={openCompanyDashboard}>
				<div class={"list-item-icon material-icons opacity-full"}>business</div>
				<Text><span class="opacity-full">Company Dashboard</span></Text>
			</Item>

			{#if User.hasFeature(Feature.SATELLITE_IMAGERY.VIEW) }
				<Item on:SMUI:action={ openMapSettings }>
					<div class={"list-item-icon material-icons opacity-full"}>map</div>
					<Text><span class="opacity-full">Map Settings</span></Text>
				</Item>
			{/if}

			<h2 class="list-heading">Logged in as:</h2>
			<Item on:SMUI:action={()=>{ }}>
				<div class={"list-item-icon material-icons opacity-full"}>person</div>
				<Text><span class="opacity-full">{$currentUserInfo.username} ({$currentUserCompanyInfo.name})</span></Text>
			</Item>
			<Item on:SMUI:action={AuthStore.actions.logout}>
				<div class={"list-item-icon material-icons opacity-full"}>logout</div>
				<Text><span class="opacity-full">Logout</span></Text>
			</Item>
		</List>
	</Menu>
</div>

